import React from "react";
import { Column } from "@ant-design/plots";

const DynamicColumnChart = ({
  data,
  xField,
  yField,
  title,
  xAxisTitle,
  yAxisTitle,
  isMaximized
}) => {
  const config = {
    data,
    xField,
    yField,
    autoFit: true,
    height: isMaximized ? 500 : 200,
    // height: 140, // ✅ chart height
    label: false,
    // label: {
    //   position: "middle",
    //   style: {
    //     fill: "#FFFFFF",
    //     opacity: 0.6,
    //   },
    //   formatter: (datum) => {
    //     const value =
    //       typeof datum === "object" && datum[yField] !== undefined
    //         ? datum[yField]
    //         : datum;
    //     const num = Number(value);
    //     return isNaN(num) ? "" : num.toFixed(2);
    //   },
    // },
    xAxis: {
      label: {
        autoRotate: false,
        rotate: 220,
      },
      title: xAxisTitle
        ? {
            text: xAxisTitle,
            style: {
              fontSize: 14,
              fontWeight: 600,
              fill: "#000",
            },
          }
        : null,
    },
    yAxis: {
      title: yAxisTitle
        ? {
            text: yAxisTitle,
            style: {
              fontSize: 14,
              fontWeight: 600,
              fill: "#000",
            },
          }
        : null,
    },
    scrollbar: {
      type: "horizontal",
    },
    meta: {
      [xField]: { alias: xField },
      [yField]: { alias: yField },
    },
    columnWidthRatio: 0.4,
  };

  return (
    <div className="my-4" style={{ width: "100%", height: "70%" }}>
      {title && <h3 className="text-center mb-2">{title}</h3>}
      <Column {...config} />
    </div>
  );
};

export default DynamicColumnChart;
